var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"min-width":"1280px"},attrs:{"id":"app"}},[(!_vm.isGame)?_c('nv-bar'):_vm._e(),_c('router-view'),(!_vm.isGame)?_c('nv-footerbar'):_vm._e(),(!_vm.isGame)?_c('nv-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }